import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './PostForm.scss';


const PostForm = () => {
  const { t } = useTranslation();
  window.dataLayer.push({"event": "attivazione_analisi_acqua_OK"});
  return <div className="PostForm" data-testid="PostForm">
    <Row>
      <Col>
        <h2 className={'case-step-title'}>{t('cases.analisi_acqua.titles.post_form')}</h2>
        <Row className="content">
          <Col>
            <i className="gc-icon-functional-send-2-col">
              <span className="path1"/>
              <span className="path2"/>
            </i>
            <p>{t('cases.analisi_acqua.post_form.sent')}</p>
            <p>{t('cases.analisi_acqua.post_form.sent_email')}</p>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row>
      <Col>
        <div className={'action-buttons'}>
          <Link to="/" className={"btn btn-primary"}>{t("common.close")}</Link>
        </div>
      </Col>
    </Row>

  </div>
};


export default PostForm;
